/* svnty-reviews.js — THE LOCK for Judge.me's write-a-review window (R126, D3-2, 2026-09-20).
 * Judge.me appends `.jdgm-write-review-modal` to <body> on open and removes it on close — no body class, so the
 * page kept scrolling behind it (on the iPhone 02:16). This watches <body>'s children and, while the modal
 * is in the DOM, holds THE ONE HOLDER (Trade's `overflow-hidden` on <body>) exactly as the size sheet and the
 * drawers do; svnty-header.js turns that into THE LOCK v3 (html.svnty-locked + the touch guard). Only released
 * by us if we were the holder — a sheet that was already open keeps its lock. */
(function () {
  'use strict';
  var HOLD = 'overflow-hidden';
  var held = false;
  function modalOpen() {
    var m = document.querySelector('.jdgm-write-review-modal');
    return !!m && getComputedStyle(m).display !== 'none';
  }
  function sync() {
    var open = modalOpen();
    if (open && !held && !document.body.classList.contains(HOLD)) {
      document.body.classList.add(HOLD);
      held = true;
      document.documentElement.classList.add('svnty-review-modal-open');
    } else if (!open && held) {
      document.body.classList.remove(HOLD);
      held = false;
      document.documentElement.classList.remove('svnty-review-modal-open');
    }
  }
  if (typeof MutationObserver === 'function') {
    new MutationObserver(sync).observe(document.body, { childList: true });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') window.setTimeout(sync, 50); });
  sync();
})();
